import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { numberFormatter } from "../../utils"
import Laptop from "../../assets/images/task/laptop.png"

const SectionRealEstate = ({ county, allCountyData }) => {
  return (
    <>
      <section className="d-table w-100 " id="realEstate">
        <Container className=" mt-5">
          <h2 className="title mb-4">Real Estate</h2>
          <p className="text-muted">
            Realtor.com's research reveals what drives areas to go from good to
            great and back again. Find out the best time to buy and sell with a
            real estate market hotness indicator. The hotness ratings for{" "}
            <span className="text-primary fw-bold">{` ${county.county} `}</span>
            are listed below.
          </p>
        </Container>
        <Container className="mt-5">
          <Row className=" d-flex justify-content-center align-items-center">
            <Col lg={6} md={6} className="ml-100 pt-2">
              <iframe
                title="Output"
                src={`https://www.realtor.com/welcome/housing-widget/map/?search=${county.county}`}
                width="100%"
                height="300"
                frameBorder="0"
              ></iframe>
            </Col>
          </Row>
        </Container>
      </section>
      {allCountyData && (
        <section className="d-table w-100 " id="rentData">
          <Container>
            <h2 className="title mb-4">Rent Data</h2>
            <p className="text-muted">
              Easily find the Fair Market Rent in your area with our free online
              service for investors. Browse up-to-date data on rent prices, home
              values, inventory, and more! Below table lists rent data for
              different zip code in{" "}
              <span className="text-primary fw-bold">{` ${county.county} `}</span>
              .
            </p>
          </Container>
          <Container className="mt-5">
            <div className="table-responsive-lg">
              <table className="table table-striped table-hover">
                <thead className="table-dark">
                  <tr className="text-center">
                    <th scope="col">#</th>
                    <th scope="col">Zip Code</th>
                    <th scope="col">Studio Rent</th>
                    <th scope="col">One Bedroom Rent</th>
                    <th scope="col">Two Bedroom Rent</th>
                    <th scope="col">Three Bedroom Rent</th>
                    <th scope="col">Four Bedroom Rent</th>
                  </tr>
                </thead>
                <tbody>
                  {allCountyData.map((countyData, index) => (
                    <tr className="text-center" key={countyData.node.id}>
                      <th scope="row">{index + 1}</th>
                      <td>{countyData.node.zip}</td>
                      <td>{numberFormatter(countyData.node.studio_rent)}</td>
                      <td>
                        {numberFormatter(countyData.node.one_bedroom_rent)}
                      </td>
                      <td>
                        {numberFormatter(countyData.node.two_bedroom_rent)}
                      </td>
                      <td>
                        {numberFormatter(countyData.node.three_bedroom_rent)}
                      </td>
                      <td>
                        {numberFormatter(countyData.node.four_bedroom_rent)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Container>
        </section>
      )}
    </>
  )
}

export default SectionRealEstate
